import { GroupDelegate } from '@leverege/molten/imagine';
import EventsEnabledItemDelegate from './EventsEnabledItemDelegate'; // eslint-disable-line import/no-cycle
import EventsGroupDelegate from './EventsGroupDelegate';

export default class EventsEnabledGroupDelegate extends GroupDelegate {
  constructor( options ) {
    super( options )

    Object.defineProperties( this, {
      eventsDelegate : {
        get : () => {
          if ( !this.hDelegate ) {
            this.eDelegate = new EventsGroupDelegate( options, this )
          }

          return this.eDelegate
        }
      }
    } )
  }

  events( query, options ) {
    return this.eventsDelegate.search( query, options )
  }

  item( id ) {
    const iRel = this.relationship.createItem( this.match, id )
    return new EventsEnabledItemDelegate( { match : iRel.match, relationship : iRel, id } )
  }

  /**
   * Returns the parent's action object. This will return an ItemAction pointed
   * at the parent holding this group
   */
  parent( ) {
    const parent = this.relationship.parent
    if ( parent == null ) {
      return null
    }

    // if parent is an item or an alias, use ItemDelegate
    if ( parent.isItem || parent.isAlias ) {
      return new EventsEnabledItemDelegate( { 
        relationship : parent, // .createResolved( this.match ), 
        match : this.match, 
        ...this.options 
      } )
    }
    
    return new EventsEnabledGroupDelegate( { 
      relationship : parent, // .createResolved( this.match ), 
      match : this.match, 
      ...this.options 
    } )
  }
}
